import { useBreakpoints } from "../../utils/use-breakpoints"
import { Flex, FlexProps, Group, GroupProps } from "@mantine/core"
import { SuspenseWithErrorBoundary } from "../suspense"
import { NavGroup, NavGroupProps } from "../NavGroup"
import { ScrollContainer } from "../scroll-container"
import { DottedMenuProps } from "../dotted-menu"
import { forwardRef } from "react"
import { ResponsiveDottedMenuActions } from "../responsive-dotted-menu-actions"

interface Props
  extends React.PropsWithChildren, Pick<NavGroupProps, "crumbOverride"> {
  buttonGroupProps?: GroupProps
  dottedMenuProps?: DottedMenuProps
  navGroupProps?: GroupProps
  infoDescription?: string
  titleGroupProps?: GroupProps
  crumbOverride?: () => React.ReactElement
  scrollContainerProps?: FlexProps
  disableHeader?: boolean
}

export const Page = forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      buttonGroupProps,
      crumbOverride,
      dottedMenuProps,
      titleGroupProps,
      navGroupProps,
      scrollContainerProps,
      disableHeader,
    },
    ref
  ) => {
    const { xs, sm } = useBreakpoints()

    return (
      <Flex mah="100%" h="100%" direction="column" ref={ref}>
        {!disableHeader && (
          <Group
            justify="space-between"
            align="center"
            wrap="nowrap"
            px={sm || xs ? "xs" : "md"}
            py={sm || xs ? "xs" : "md"}
            h={xs || sm ? undefined : "60px"}
            {...titleGroupProps}
          >
            <NavGroup
              flex={1}
              crumbOverride={crumbOverride}
              {...navGroupProps}
            />
            <ResponsiveDottedMenuActions
              buttonGroupProps={buttonGroupProps}
              dottedMenuProps={dottedMenuProps}
            />
          </Group>
        )}

        <ScrollContainer
          px={sm || xs ? "sm" : "md"}
          mb={sm || xs ? undefined : "md"}
          direction="column"
          flex={1}
          {...scrollContainerProps}
        >
          <SuspenseWithErrorBoundary>{children}</SuspenseWithErrorBoundary>
        </ScrollContainer>
      </Flex>
    )
  }
)
